
import React from "react";
import { useIsMobile } from "@/hooks/use-mobile";

const TransitionSection = () => {
  const isMobile = useIsMobile();
  
  return (
    <div className={`relative w-full overflow-hidden ${isMobile ? 'py-16' : 'py-32'} mt-0 ${isMobile ? 'min-h-[250px]' : 'min-h-[300px]'} bg-white`}>
      <div className="absolute inset-0 w-full h-full z-0">
        <img 
          src="https://bbhhusjprzalcwvkgvsa.supabase.co/storage/v1/object/public/photos//Blush%20Wave%20LinkedIn%20Banner.png" 
          alt="Soft white wave background" 
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/70"></div>
      </div>
      
      {/* Centered quote with white text */}
      <div className={`container mx-auto px-6 ${isMobile ? 'py-8' : 'py-12'} relative z-20`}>
        <div className="max-w-3xl mx-auto text-center">
          <div>
            <h3 className={`font-playfair ${isMobile ? 'text-2xl' : 'text-3xl md:text-4xl'} text-white font-semibold mb-4`}>
              "For He satisfies the longing soul, and fills the hungry soul with goodness."
            </h3>
            <p className="text-white/70 text-lg md:text-xl font-medium">— Psalm 107:9</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TransitionSection;
